import type { OnChanges, SimpleChanges } from '@angular/core';
import { Component, Input } from '@angular/core';

import { EmojiSupportService } from '../emoji-support.service';

@Component({
  selector: 'rt-emoji',
  templateUrl: './emoji.component.html',
  styleUrls: ['./emoji.component.less'],
  host: {
    '[class.emoji-fallback]': '!!fallbackUrl',
    '[style.background-image]': 'fallbackUrl',
    '[style.font-size.px]': 'size',
    '[style.width.px]': '!!fallbackUrl && size',
    '[style.height.px]': '!!fallbackUrl && size',
  },
  standalone: true,
})
export class EmojiComponent implements OnChanges {
  @Input() public emoji: string;
  @Input() public size: 14 | 20 | 24;

  public fallbackUrl: string | null = null;

  constructor(private emojiSupportService: EmojiSupportService) {}

  public ngOnChanges(changes: SimpleChanges): void {
    const { emoji } = changes;

    if (emoji) {
      this.onEmojiChanged();
    }
  }

  public onEmojiChanged() {
    const emojiSupported = this.emojiSupportService.isEmojiSymbolSupported(this.emoji);

    if (emojiSupported) {
      this.fallbackUrl = null;
    } else {
      const fallbackUrl = this.emojiSupportService.getFallbackImgUrl(this.emoji);
      this.fallbackUrl = fallbackUrl ? `url('${fallbackUrl}')` : null;
    }
  }
}
